import { EnumTranslationPipe } from './enum-translation.pipe';
import { UNIT_SYMBOLS } from './unit-symbols';
import { CustomFieldCompositionDto } from '@artemis-software/wr-api';
import { Pipe, PipeTransform } from '@angular/core';
import UnitEnum = CustomFieldCompositionDto.UnitEnum;

const UNIT_NAMES: Record<UnitEnum, string> = {
  Meter: 'Meter',
  Centimeter: 'Zentimeter',
  Millimeter: 'Millimeter',
  Kilogram: 'Kilogramm',
  Gram: 'Gramm',
  Celsius: 'Grad Celsius',
  Liter: 'Liter',
  Milliliter: 'Milliliter',
  SquareMeter: 'Quadratmeter',
  Kilowatt: 'Kilowatt',
  KilowattHour: 'Kilowattstunde',
  Bar: 'Bar',
  Pascal: 'Pascal',
  Percent: 'Prozent',
  Euro: 'Euro',
  GermanHardness: 'Deutsche Härte',
  Tonne: 'Tonne',
  Megawatt: 'Megawatt',
  MegawattHour: 'Megawattstunde',
  CubicMeter: 'Kubikmeter',
  MicrosiemensPerCentimeter: 'Elektrische Leitfähigkeit',
  MillimolPerLiter: 'Säurekapazität',
  MilligramPerLiter: 'Massenkonzentration',
  MilligramPerCubicMeter: 'Massenkonzentration',
  LiterPerMinute: 'Volumenstrom',
  LiterPerHour: 'Durchsatz',
  Volt: 'Volt',
  Ampere: 'Ampere',
  Ohm: 'Ohm',
  Kelvin: 'Kelvin',
  Hectopascal: 'Hectopascal',
};

@Pipe({
  standalone: false,
  name: 'unitTranslation',
})
export class UnitTranslationPipe implements EnumTranslationPipe<UnitEnum>, PipeTransform {
  transform(value: UnitEnum): string {
    const name = UNIT_NAMES[value];
    const symbol = UNIT_SYMBOLS[value];
    if (name === undefined || symbol === undefined) {
      return value;
    }
    return `${name} (${symbol})`;
  }
}
